// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestArrow {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _arrow?: vf.gui.Arrow;
    private _buttonList: vf.gui.Label[] = [];
    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制 */
        const arrow = this._arrow = new vf.gui.Arrow();
        arrow.width = 200;
        arrow.height = 80;
        arrow.x = 300;
        arrow.y = 400;
        arrow.lineColor = 0xff0000;
        arrow.color = 0xffffff;
        arrow.fillAlpha = 0.5;
        arrow.lineWidth = 3;
        uiStage.addChild(arrow);
        arrow.anchorX = 0.5
        arrow.anchorY = 0.5;

        this.getButton('设置/取消width\/height', () => {
            if (arrow.width === 200) {
                arrow.width = 300;
                arrow.height = 50;
            } else {
                arrow.width = 200;
                arrow.height = 80;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 虚线(虚线不能填充)', () => {
            if (arrow.lineType === "full") {
                arrow.lineType = "dash";
            } else {
                arrow.lineType = "full";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 fillColor', () => {
            if (arrow.style.fillGradientType !== 1) {
                arrow.style.fillGradientType = 1
                arrow.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                arrow.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            } else {
                arrow.style.fillGradientType = 0
                arrow.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                arrow.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            }

        }, uiStage, 650, 0);
    }


    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
    }
    private onRelease() {
        if (this._arrow) {
            this._arrow.removeAllListeners();
            this._arrow.parent && this._arrow.parent.removeChild(this._arrow);
            this._arrow.release();
            this._arrow = undefined;
        }

        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }

}

